import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { uniqueIdForComponent, flatten } from '../util';
import SectionHeaderAction from './SectionHeaderAction';

var Section = /*#__PURE__*/function (_Component) {
  _inherits(Section, _Component);

  function Section(props) {
    var _this;

    _classCallCheck(this, Section);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Section).call(this, props));
    _this.state = {
      titleId: uniqueIdForComponent()
    };
    return _this;
  }

  _createClass(Section, [{
    key: "render",
    value: function render() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var children = _ref.children,
          className = _ref.className,
          title = _ref.title,
          ariaLabelledBy = _ref.ariaLabelledBy,
          light = _ref.light,
          dark = _ref.dark,
          primary = _ref.primary,
          otherProps = _objectWithoutProperties(_ref, ["children", "className", "title", "ariaLabelledBy", "light", "dark", "primary"]);

      var wrapperClasses = classNames('wds-c-section', className, {
        'wds-c-section--light': light
      }, {
        'wds-c-section--dark': dark
      }, {
        'wds-c-section--primary': primary
      });

      if (ariaLabelledBy && title) {
        console.warn('Either ariaLabelledBy or title prop should be present, not both.');
      }

      var sectionChildren = [];

      if (Array.isArray(children)) {
        sectionChildren = flatten(children);
      } else {
        sectionChildren = flatten([children]);
      }

      var sectionHeaderActions = sectionChildren.filter(function (element) {
        return element && element.type && element.type.displayName === SectionHeaderAction.displayName;
      });
      var sectionContent = sectionChildren.filter(function (element) {
        return !element || !element.type || element.type.displayName !== SectionHeaderAction.displayName;
      });
      var hasHeaderActions = sectionHeaderActions.length !== 0;
      var headingContainer = React.createElement("div", {
        className: "wds-c-section-heading"
      }, React.createElement("h2", {
        id: this.state.titleId,
        className: "wds-c-section-heading__title"
      }, title), hasHeaderActions && sectionHeaderActions);
      return React.createElement("section", _extends({}, ariaLabelledBy !== undefined && {
        'aria-labelledby': ariaLabelledBy
      }, title && {
        'aria-labelledby': this.state.titleId
      }, {
        className: wrapperClasses
      }, otherProps), title || hasHeaderActions ? headingContainer : null, sectionContent);
    }
  }]);

  return Section;
}(Component);

Section.propTypes = {
  /** child elements */
  children: PropTypes.node.isRequired,

  /** class name */
  className: PropTypes.string,

  /** indicates a light section */
  light: PropTypes.bool,

  /** indicates a dark section */
  dark: PropTypes.bool,

  /** indicates a primary section, includes gradient */
  primary: PropTypes.bool,

  /** renders the section title */
  title: PropTypes.node,

  /** required for accessibility */
  ariaLabelledBy: PropTypes.string
};
Section.defaultProps = {
  className: undefined,
  light: false,
  dark: false,
  primary: false,
  title: undefined,
  ariaLabelledBy: undefined
};
export default Section;